<div class="gnd-infobox" id="gnd-infobox-{{ entity.gndIdentifier }}"
     style="width: {{ self.width }}px">
  {{#if opts.showThumbnail}}
  <img class="gnd-infobox-image" style="float: right; max-width: 200px; max-height:200px; margin-left: 5px; margin-bottom: 5px" src="{{ self.endpoint }}/gnd/{{ entity.gndIdentifier }}/image?width={{ opts.thumbnailWidth }}"/>
  {{/if}}
  <div class="gnd-infobox-header" style="position: static; top: 0;right: 0;">
    <dl>
      <dt class="gnd-infobox-preferredname">{{preferredName entity}}</dt>
      <dd>        
        <a href="http://d-nb.info/gnd/{{ entity.gndIdentifier }}">GND: {{ entity.gndIdentifier }}</a>        
      </dd>      
      {{#if opts.showTypes}}
      {{#each (arrayify entity.[@type]) }}
      <dd class="gnd-infobox-type">
        {{this}}
      </dd>
      {{/each}}
      {{/if}}
  </div>
  <div style="clear: both"></div>
  <table class="gnd-infobox-table">
    <tbody>
      {{{ content }}}
    </tbody>
  </table>
</div>
